import { createFileRoute } from '@tanstack/react-router'
import WriteSyncOperationList from '../components/write-sync-operation-list/WriteSyncOperationList'

export const Route = createFileRoute('/_a/writeSyncOperations')({
  component: WriteSyncOperationList,
})
